<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare content='店员分为店长、店员权限角色' :padding='false'></SmallSquare>
      <div class="mb25 s_flex_bian_c m-t-20">
        <div>
          <span class='mr15'>
            <a-button type="primary" v-has:clerkCreate="()=>addClerkBnt(0,'add')">
              <PlusOutlined />
              新增店员
            </a-button>
          </span>
        </div>
        <div>
          <span class='mr15'>
            <a-button type="primary" ghost v-has:clerkInvitation="()=>{visibleInvite=true}">
              店员注册地址
            </a-button>
          </span>
          <span>
            <a-button type="primary" ghost v-has:clerkLoginUrl="()=>getClerkLink(5)">
              店员登录地址
            </a-button>
          </span>
        </div>
      </div>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="关键词" class='mb15' name='keywords'>
          <a-input v-model:value="search.keywords" placeholder="请输入店员名称/手机号" />
        </a-form-item>
        <a-form-item label="核销权限" name='is_can_verify' v-if='open'>
          <a-select v-model:value="search.is_can_verify" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">有</a-select-option>
            <a-select-option :value="0">无</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="创建时间" name='time' v-if='open'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChangeTime" />
        </a-form-item>
        <a-form-item label="所属经销商" name='dealer_id' v-if='open'>
          <a-input v-model:value="dealer_name" readonly placeholder='请选择所属经销商' />
          <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 3px;" v-if='dealer_name' @click='dealer_name="";search.dealer_id="";' />
        </a-form-item>
        <a-form-item label="" name='' v-if='open'>
          <a-button type="primary" @click='showDealer = true'>选择</a-button>
        </a-form-item>
        <a-form-item label="店员角色/级别" name='level_id' v-if='open'>
          <a-select v-model:value="search.type_id" :style="{width:'140px'}" @change="handleChange">
            <a-select-option value="">全部角色</a-select-option>
            <a-select-option v-for='item in typeList' :key='item.id' :value="item.id">{{item.type_name}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="" name='' v-if='open'>
          <a-select v-model:value="search.level_id" :style="{width:'140px'}" :disabled="!search.type_id">
            <a-select-option value="">全部级别</a-select-option>
            <a-select-option v-for='item in levelList' :key='item.id' :value="item.id">{{item.level_name}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="绑定微信账号" name='is_bind_wechat' v-if='open'>
          <a-select v-model:value="search.is_bind_wechat" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">绑定微信</a-select-option>
            <a-select-option :value="2">未绑定微信</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item ref="" label="所属上级" name="" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }" class="m-r-20" v-if='open'>
          <a-row :gutter="10">
            <a-col :span="8" hidden>
              <a-input readonly v-model:value='search.parent_id' placeholder="上级ID"></a-input>
            </a-col>
            <a-col :span="20">
              <a-input readonly v-model:value='search.parent_name' placeholder="上级名称"></a-input>
            </a-col>
            <a-col :span="4">
              <a-button type="primary" @click='showStore=true;selectType=1'>选择</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button v-has:clerkExport="exportTable">导出</a-button>
        </a-form-item>
        <!-- <a-form-item>
          <a-button type="primary" ghost>导入</a-button>
        </a-form-item>  -->
        <a-form-item>
          <a href="javascript:;" @click='open = !open'>{{open ? '收起':'展开'}}</a>
          <UpOutlined v-if='open' />
          <DownOutlined v-else />
        </a-form-item>
      </a-form>
      <a-table class='tableFixBox' :pagination='false' :loading='listLoading' bordered rowKey='id' :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" :columns='columns' :data-source='data' :scroll="{ x: 'max-content'}">
        <template v-slot:is_bind_wechat="{ record }">
          <a-popover placement="right" v-if='record.wechat'>
            <template #content>
              <div class="s_flex_ali">
                <img class="width-100 height-100 m-r-15" :src="record.wechat ? record.wechat.headimgurl :''" alt="">
                <div>
                  <p class="s_c333 s_lin_h28">微信昵称：{{record.wechat ? record.wechat.nick_name :'-'}}</p>
                  <p class="s_c333 s_lin_h28">客户ID：{{record.wechat ? record.wechat.id :'-'}}</p>
                  <p class="s_c333 s_lin_h28">地区：{{record.wechat ? record.wechat.area :'-'}}</p>
                  <p class="s_c333 s_lin_h28">会员等级：{{record.wechat ? record.wechat.vip_level :'-'}}</p>
                </div>
              </div>
            </template>
            <a href="javascript:;" class="s_omit width-120 ds-b">{{record.wechat ? record.wechat.nick_name :'-'}}</a>
          </a-popover>
          <p v-else>-</p>
        </template>
        <template v-slot:action="{ record }">
          <a-button v-has:clerkDetail="()=>addClerkBnt(record,'look')" class="m-r-10">详情</a-button>
          <a-button v-has:clerkEdit="()=>addClerkBnt(record,'edit')" class="m-r-10" type="primary">修改</a-button>
          <a-button v-has:clerkStatus="()=>clerkDisable(record)" class="m-r-10" danger>{{record.status ? '禁用':'启用'}}</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
  <a-modal :keyboard="false" title="添加店员申请链接" centered :footer="null" v-model:visible="visibleInvite" destroyOnClose>
    <a-form-item label="店员角色/级别" name='' :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
      <a-row :gutter="10">
        <a-col :span="8">
          <a-select v-model:value="formLink.level" placeholder="请选择" :style="{width:'100%'}" @change="handleChange">
            <a-select-option v-for='item in typeList' :key='item.id' :value="item.id">{{item.type_name}}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="12">
          <a-select v-model:value="formLink.level_id" placeholder="请选择" :style="{width:'100%'}">
            <a-select-option v-for='item in levelList' :key='item.id' :value="item.id">{{item.level_name}}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item ref="" label="上级门店" name="" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
      <a-row :gutter="10">
        <a-col :span="8">
          <a-input readonly v-model:value='formLink.store_id' placeholder="上级ID"></a-input>
        </a-col>
        <a-col :span="12">
          <a-input readonly v-model:value='formLink.name' placeholder="上级名称"></a-input>
        </a-col>
        <a-col :span="4">
          <a-button type="primary" @click='showStore=true;selectType=2'>选择</a-button>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 8, offset: 5 }">
      <a-button type="primary" @click="Registered">
        生成申请链接
      </a-button>
    </a-form-item>
 </a-modal>
   <a-modal  :keyboard="false" title="选择门店" v-model:visible="showStore" centered :width='1300' :footer="null" destroyOnClose>
    <selectStore  :checkout='false' v-on:select="storeSelect" :selectList='[{id:formLink.store_id}]' :hiddenHead='true'></selectStore>
  </a-modal>
  <a-modal  :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1300' :footer="null" destroyOnClose>
    <selectDealer v-on:select="dealerSelect"></selectDealer>
  </a-modal>
  <a-modal  :keyboard="false" centered :title="type=='add'?'添加店员':type == 'look'?'店员详情':'店员修改'" :width='1300'  :footer="null" v-model:visible="visible"
    destroyOnClose>
    <clerkAdd  v-on:onsubmit='onsubmit' v-on:typechange='typechange' :formData='formData' :typeList='typeList' :levelList='levelList'></clerkAdd>
  </a-modal>
  <a-modal :keyboard="false" title="复制链接" centered :width='600' :footer="null" v-model:visible="visibleUrl" destroyOnClose>
    <div class="s_flex_bian_c">
      <div class="s_bor_r_cd9 p-r-20">
        <img class="width-160 height-160" :src="link.image" alt="">
        <p class="text-ac m-t-10">微信扫一扫立即预览</p>
      </div>
      <div class="width63">
        <p class="s_c333 s_font_b fz-16">复制地址</p>
        <div class="m-t-15 m-b-15 s_flex_bian_c">
          <a-input class="width80" v-model:value="link.link" readonly></a-input>
          <a-button type="primary" ghost @click="copy(link.link)">复制</a-button>
        </div>
        <p class="s_c999 ">可将链接复制到您的公众号菜单中</p>
      </div>
    </div>
  </a-modal>
</template>
<script>
import {
  DownOutlined,
  PlusOutlined,
  UpOutlined,
  CloseCircleFilled,
} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import {
  getStoreClerkList,
  getTypeList,
  getStoreClerkListExport,
  getLevelList,
  storeClerkAdd,
  storeClerkEdit,
  storeClerkStatus,
  getInviteRegistered,
} from "@/api/clerk";
import { getClientsite } from "@/api/public";
import { iscode } from "@/utils/app";
import clerkAdd from "./clerk_add";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 8,
  keywords: "",
  is_can_verify: "",
  is_wx_auth: "",
  start_time: "",
  end_time: "",
  dealer_id: "",
  level_id: "",
  type_id: "",
  is_bind_wechat: "",
  parent_id:"",
  parent_name:""
};
export default {
  components: {
    DownOutlined,
    PlusOutlined,
    clerkAdd,
    UpOutlined,
    CloseCircleFilled,
  },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      selectType: 1,
      dealer_name: "",
      open: false,
      visibleUrl: false,
      showDealer: false,
      formData: {},
      typeList: [],
      levelList: [],
      time: [],
      type: "add",
      visible: false,
      listLoading: false,
      total: 1,
      selectedRowKeys: [],
      link: {}, //链接数据
      visibleInvite: false, //店员注册连接弹窗
      formLink: {
        level_id: null,
        level: null,
      }, //注册连接参数
      showStore: false, //选择门店弹框
    });
    let columns = [
      {
        title: "店员姓名",
        dataIndex: "clerk_name",
        key: "clerk_name",
      },
      {
        title: "店员类型",
        dataIndex: "type_name",
        key: "type_name",
        customRender: ({ record }) => {
          return record.type_name ? record.type_name : "-";
        },
      },
      {
        title: "登录账号",
        dataIndex: "clerk_phone",
        key: "clerk_phone",
      },
      {
        title: "绑定微信账号",
        dataIndex: "is_bind_wechat",
        key: "is_bind_wechat",
        slots: { customRender: "is_bind_wechat" },
      },
      // {
      //   title: "绑定微信",
      //   dataIndex: "is_wx_auth_text",
      //   key: "is_wx_auth_text",
      // },
      {
        title: "核销权限",
        dataIndex: "is_can_verify_text",
        key: "is_can_verify_text",
      },
      {
        title: "店员级别",
        dataIndex: "level_name",
        key: "level_name",
        customRender: ({ record }) => {
          return record.level_name ? record.level_name : "-";
        },
      },
      {
        title: "所属门店",
        dataIndex: "store_name",
        key: "store_name",
        customRender: ({ record }) => {
          return record.store_name ? record.store_name : "-";
        },
      },
      {
        title: "所属经销商",
        dataIndex: "dealer_name",
        key: "dealer_name",
        customRender: ({ record }) => {
          return record.dealer_name ? record.dealer_name : "-";
        },
      },
      {
        title: "状态",
        dataIndex: "status_text",
        key: "status_text",
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "最后登录时间",
        dataIndex: "login_time",
        key: "login_time",
      },
      {
        title: "操作",
        key: "action",
        width: 100,
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    //选择经销商
    const dealerSelect = (e) => {
      if (e == 0) {
        state.dealer_name = "总部";
        search.value.dealer_id = e;
      } else {
        state.dealer_name = e.dealer_name;
        search.value.dealer_id = e.dealer_id;
      }
      state.showDealer = false;
    };
    //获取类型
    const getType = async () => {
      let res = await getTypeList().then((res) => res.data);
      if (iscode(res)) {
        state.typeList = res.data.data;
      } else {
        message.error(res.msg);
      }
    };
    //选择类型
    const handleChange = (e) => {
      if (e) {
        getLevel(e);
      } else {
        search.value.level_id = "";
      }
    };
    //添加选择类型
    const typechange = (e) => {
      getLevel(e);
    };
    //获取级别
    const getLevel = async (e) => {
      let res = await getLevelList({ type_id: e }).then((res) => res.data);
      if (iscode(res)) {
        state.levelList = res.data.data;
      } else {
        message.error(res.msg);
      }
    };
    //添加/编辑
    const addClerkBnt = (e, type) => {
      if (type == "add") {
        state.visible = true;
        state.formData = {
          type: type,
        };
        state.type = "add";
      } else if (type == "look") {
        state.visible = true;
        state.formData = {
          id: e.id,
          type: type,
        };
        state.type = "look";
      } else {
        state.visible = true;
        state.formData = {
          id: e.id,
          type: type,
        };
        state.type = "edit";
      }
    };
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChangeTime = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData(search.value);
    };
    //删除代理商
    const clerkDisable = (e) => {
      $Modal.confirm({
        centered: true,
        title: "店员操作",
        content: "您确定要" + (e.status ? "禁用" : "启用") + "该店员吗？",
        onOk: async () => {
          let res = await storeClerkStatus(e.id, e.status ? 0 : 1).then(
            (res) => res.data
          );
          if (iscode(res)) {
            message.success(res.msg);
            initData(search.value);
          } else {
            message.error(res.msg);
          }
        },
      });
    };
    //批量选中
    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys;
    };
    const onsubmit = async (form) => {
      let res;
      const hide = message.loading("正在加载中...", 0);
      if (state.type == "add") {
        res = await storeClerkAdd(form).then((res) => res.data);
      } else {
        res = await storeClerkEdit(form, state.formData.id).then(
          (res) => res.data
        );
      }
      if (iscode(res)) {
        setTimeout(hide);
        message.success(res.msg);
        setTimeout(() => {
          state.visible = false;
          initData(search.value);
          state.type == "add";
        }, 1000);
      } else {
        setTimeout(hide);
        message.error(res.msg);
      }
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getStoreClerkList(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const inputSelect = (e) => {
      search.value.keywords = "";
    };
    const getClerkLink = async (client_type) => {
      let result = await getClientsite({ client_type })
        .then((res) => res.data)
        .catch((error) => error);
      state.link = result.data;
      state.visibleUrl = true;
    };
    // 复制
    const copy = (link) => {
      var input = document.createElement("input"); // 直接构建input
      input.value = link; // 设置内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      message.success("复制成功");
    };
    const storeSelect = (data) => {
      if (state.selectType == 1) {
        if (data == 0) {
          search.value.parent_name = "总部";
          search.value.parent_id = 0;
        } else {
          search.value.parent_name = data.store_name;
          search.value.parent_id = data.id;
        }
      } else {
        if (data == 0) {
          state.formLink.name = "总部";
          state.formLink.store_id = 0;
        } else {
          state.formLink.name = data.store_name;
          state.formLink.store_id = data.id;
        }
      }

      state.showStore = false;
    };
    const Registered = async () => {
      if (!state.formLink.store_id) {
        message.error("请选择上级门店！");
        return;
      }
      // formLink
      let res = await getInviteRegistered({ ...state.formLink })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        state.link = { ...res.data, link: res.data.url };
        state.visibleUrl = true;
        state.visibleInvite = false;
      } else {
        message.error(res.msg);
      }
    };
    onMounted(() => {
      getType();
      initData(search.value);
    });
    // 导出
    const exportTable = async () => {
      let res = await getStoreClerkListExport({
        ...search.value,
        limit: 5000,
        excel: 1,
      }).then((res) => res.data);
      if (iscode(res, true)) {
        window.open(res.data.action);
      }
    };
    return {
      ...toRefs(state),
      search,
      exportTable,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onsubmit,
      onChangeTime,
      clerkDisable,
      onSelectChange,
      addClerkBnt,
      handleChange,
      typechange,
      inputSelect,
      getClerkLink,
      storeSelect,
      Registered,
      copy,
      dealerSelect,
    };
  },
};
</script>
<style>
.ant-table td {
  white-space: nowrap;
}
</style>